<template>
  <div>
    <b-modal id="modalEditRentsoftSetting" ref="modalEditRentsoftSetting" @shown="shown"
      :title="$t('Services and tariffs connect')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox switch size="lg" v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.accounting_period_id" :options="accountingPeriods" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Post paid')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox switch size="lg" v-model.number="editItem.is_post_paid" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Juridical')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox switch size="lg" v-model.number="editItem.is_juridical" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Time shift')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model.number="editItem.time_shift"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-row>
            <b-col>
              <b-form-select v-model="selectedTariff" :options="tariffs" />
            </b-col>
            <b-col>
              <md-button style="margin-top:0rem" class="md-raised" @click="addTarrif" >{{ $t('Add') }}</md-button>
            </b-col>
          </b-row>

        </b-form-group>
        <b-card v-if="editItem.tariffs.length > 0">
          <b-list-group>
            <b-list-group-item id="button-list-group-item" v-for="item in editItem.tariffs" :key="item">
              <b style="font-weight: bold;"> {{ tariffIDToName(item) }}</b>
              <i @click.stop="deleteTariff(item)" class="danger fa fa-trash-alt fa-lg" />
            </b-list-group-item>
          </b-list-group>
        </b-card>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditRentsoftSetting')" size="md"/>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  data () {
    return {
      selectedTariff: null,
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'tariff_id', label: 'Tariff ID', sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  props: {
    editItem: null
  },
  methods: {
    deleteTariff (tariffID) {
      this.editItem.tariffs = this.editItem.tariffs.filter(el => {
        return el !== tariffID
      })
    },
    tariffIDToName (tariffID) {
      for (let el of this.tariffsAll) {
        if (el.value === tariffID) {
          return el.text
        }
      }
      return 'Not found name'
    },
    addTarrif () {
      if (this.selectedTariff) {
        this.editItem.tariffs.push(JSON.parse(JSON.stringify(this.selectedTariff)))
      }
      this.selectedTariff = null
    },
    save () {
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_RENTSOFT_SETTINGS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_RENTSOFT_SETTINGS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_RENTSOFT_SETTINGS')
          this.$refs.modalEditRentsoftSetting.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id === 0 && this.groups.length) {
        this.editItem.group_id = this.groups[0].value
      }
    }
  },
  computed: {
    groups () {
      let res = []
      res.push({value: 0, text: this.$t('All')})
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      return res
    },
    accountingPeriods () {
      let res = []
      for (let el of this.$store.getters['Tariffing/ACCOUNTING_PERIODS']) {
        if (el.id === 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.static_id
        let accPeriodName = ''
        switch (el.periodic_type) {
          case 1:
            accPeriodName = this.$i18n.t('Daily')
            break
          case 2:
            accPeriodName = this.$i18n.t('Weekly')
            break
          case 3:
            accPeriodName = this.$i18n.t('Monthly')
            break
          case 4:
            accPeriodName = this.$i18n.t('Quarterly')
            break
          case 5:
            accPeriodName = this.$i18n.t('Annual')
            break
          default:
            accPeriodName = this.$i18n.t('CustomDuration')
            break
        }
        newEl.text = el.id + ' (' + this.$root.getMomentWithTZDelta(Number(el.begin)).format('DD-MM-YYYY') + '-' + this.$root.getMomentWithTZDelta(Number(el.end)).format('DD-MM-YYYY') + ') ' + accPeriodName
        res.push(newEl)
      }
      return res
    },
    tariffs () {
      let res = []
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        if (el.id === 0) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        newEl.text = '(' + el.id + ') ' + el.name
        res.push(newEl)
      }
      res = res.filter(el => {
        return !this.editItem.tariffs.includes(el.value)
      })
      return res
    },
    tariffsAll () {
      let res = []
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        if (el.id === 0) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        newEl.text = '(' + el.id + ') ' + el.name
        res.push(newEl)
      }
      return res
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/rentsoft/editModal.vue